define('views/parts/alert/alert-no-data',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/parts/alert/alert-no-data.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TAlertNoData
) {

    var VAlertNoData = Backbone.View.extend({
        template: TAlertNoData,
        events: {
            "click .close": "onClose",
        },

        regions: {
            root: '.alert-nodata'
        },

        initialize: function(opt) {
            this.options = _.extend({
                title: 'Add new data',
                caret: true,
                addClass: ""
            }, opt);

            this.listenTo(this.collection, {
                "sync update reset": this.toggleAlert,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));
            this.generateZones()
                .toggleAlert()
                .toggleCaret();

            return this;
        },

        toggleAlert: function() {
            if (this.zone) {
                this.zone.$root.toggleClass('alert-hidden', Boolean(this.collection.length));
            }
            return this;
        },

        toggleCaret: function() {
            this.zone.$root.toggleClass('hidden-caret', !this.options.caret);
        },

        setCollection: function(collection) {
            this.collection = collection;
            return this;
        },

        show: function() {
            this.$el.removeClass("transparent");
        },

        onClose: function(e) {
            this.model.trigger("alert:close", this.model);
        },

    });

    return VAlertNoData;

});

